import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'delete-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="d-flex-align-items-center justify-content-center">
    @if(rowData.canDelete || rowData.canDelete == undefined){
    <button class="dp-secondary-btn delete-btn" (click)="onCellClick(rowData)">
  
        <img src='../../assets/images/delete-cell.svg' />

    </button>
    }
  </div>
  `,
  styles: [
    `
      .delete-btn {
        width: 36px;
        height: 32px;
      }
    `,
  ],
})
export class DeleteCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  onCellClick(rowData: any) {
    console.log(rowData)

    this.cellClick.emit(rowData);
  }
}
